// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2gQyfPjAFX-Hr6Zkmb9jgn"};